interface StepItem {
  number: string;
  title: string;
  description: string;
  icon: string;
}

interface BuyingGuideSectionProps {
  sectionTitle: string;
  sectionSubtitle: string;
  steps: StepItem[];
}

export default function BuyingGuideSection({ sectionTitle, sectionSubtitle, steps }: BuyingGuideSectionProps) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {sectionTitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {sectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-10">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center">
              {index < steps.length - 1 && (
                <div className="hidden sm:block absolute top-12 left-[60%] w-[80%] h-px bg-background-300">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-primary-400"></div>
                </div>
              )}
              <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-5 relative cursor-default">
                <span className="font-heading text-2xl font-bold">{step.number}</span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line"></i>
            <span>立即选购爱威奶</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

import { Link } from "react-router-dom";